import { render, staticRenderFns } from "./user-applications.component.vue?vue&type=template&id=5b0b40b6"
import script from "./user-applications.component.ts?vue&type=script&lang=ts&external"
export * from "./user-applications.component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-applications.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports